// extracted by mini-css-extract-plugin
export var formContainer = "_jv-0";
export var message = "_jv-1";